"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var MarketplaceEmptySearch = function MarketplaceEmptySearch(_ref) {
  var image = _ref.image,
      search = _ref.search,
      hasFilters = _ref.hasFilters,
      wrapperProps = (0, _objectWithoutProperties2["default"])(_ref, ["image", "search", "hasFilters"]);
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, wrapperProps), /*#__PURE__*/_react["default"].createElement("img", {
    src: image,
    alt: ""
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mt: 1,
    color: "grey.main",
    fontFamily: "Lato"
  }, !!search && !hasFilters && "There are no products for \"".concat(search, "\"."), !search && hasFilters && 'There are no products for selected filters.', !!search && hasFilters && "There are no products for \"".concat(search, "\" and selected filters."), !search && !hasFilters && "There are no products available."));
};

var _default = /*#__PURE__*/(0, _react.memo)(MarketplaceEmptySearch);

exports["default"] = _default;